import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import styled from "styled-components";
import { SignUpElement, SignUpType, usePopSignUp } from "@faire/retailer-visitor-shared/lib/popSignUp";
export var ConsumerModeBanner = function() {
    var isMobile = useViewport().isMobile;
    var popSignUp = usePopSignUp().popSignUp;
    return /*#__PURE__*/ _jsx(BannerWrapper, {
        justify: "center",
        children: /*#__PURE__*/ _jsx(Typography, {
            align: "center",
            children: isMobile ? "Shopper Mode: Browse here, buy on partner sites." : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    "Shopper Mode: Browse here, buy on partner sites. Or ",
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "tertiary",
                        onClick: function() {
                            return popSignUp(SignUpType.GENERIC, function() {}, {
                                element: SignUpElement.TOP_BANNER,
                                sourceId: "consumer-mode-banner"
                            });
                        },
                        children: "sign up"
                    }),
                    " for buying access if you have a retailer license."
                ]
            })
        })
    });
};
var BannerWrapper = styled(Column).withConfig({
    componentId: "sc-36871182-0"
})([
    "background-color:",
    ";height:40px;"
], Decorative.tint.blue);
